export default "__VITE_ASSET__DGt8fTey__"